import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoginPage from './service/LoginPage';
import Home from './service/Home';
import Usuarios from './service/Usuarios';
import SelecionaEntidade from './service/SelecionaEntidade';
import Entidades from './service/Entidades';
import SessionsAtivas from './service/SessionsAtivas';
import Demandas from './service/Demandas';
import Orgaos from './service/Orgaos';
import Imagens from './service/Imagens';
import Margens from './service/Margens';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/seleciona_entidade" element={<SelecionaEntidade />} />
        <Route path="/entidades" element={<Entidades />} />
        <Route path="/sessions-ativas" element={<SessionsAtivas />} />
        <Route path="/demandas" element={<Demandas />} />
        <Route path="/orgaos" element={<Orgaos />} />
        <Route path="/imagens" element={<Imagens />} />
        <Route path="/margens" element={<Margens />} />
      </Routes>
    </Router>
  );
}

export default App;
